var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76253 7.50583C8.97242 7.29594 9.07736 7.04189 9.07736 6.74367C9.07736 6.44533 8.97242 6.19122 8.76253 5.98133C8.55275 5.77156 8.2987 5.66667 8.00036 5.66667C7.70203 5.66667 7.44798 5.77156 7.2382 5.98133C7.02831 6.19122 6.92336 6.44533 6.92336 6.74367C6.92336 7.04189 7.02831 7.29594 7.2382 7.50583C7.44798 7.71561 7.70203 7.8205 8.00036 7.8205C8.2987 7.8205 8.55275 7.71561 8.76253 7.50583ZM8.00036 13.118C9.25337 12.0273 10.244 10.9181 10.9722 9.79033C11.7004 8.66256 12.0645 7.68717 12.0645 6.86417C12.0645 5.6445 11.6784 4.63783 10.9062 3.84417C10.134 3.05061 9.16537 2.65383 8.00036 2.65383C6.83536 2.65383 5.86675 3.05061 5.09453 3.84417C4.32231 4.63783 3.9362 5.6445 3.9362 6.86417C3.9362 7.68717 4.30031 8.66256 5.02853 9.79033C5.75675 10.9181 6.74736 12.0273 8.00036 13.118ZM8.00036 14.0128C6.4337 12.6274 5.25359 11.3353 4.46003 10.1365C3.66636 8.93783 3.26953 7.84705 3.26953 6.86417C3.26953 5.45383 3.72875 4.29056 4.6472 3.37433C5.56553 2.45811 6.68325 2 8.00036 2C9.31748 2 10.4352 2.45811 11.3535 3.37433C12.272 4.29056 12.7312 5.45383 12.7312 6.86417C12.7312 7.84705 12.3344 8.93783 11.5407 10.1365C10.7471 11.3353 9.56703 12.6274 8.00036 14.0128Z",
    fill: "#4D54D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContext);
export default __webpack_public_path__ + "static/media/context.c818c23640d4999522e735ab7d2964ba.svg";
export { ForwardRef as ReactComponent };